import { Setting, SystemSettingNameDto, SystemSettingNewDto, systemSettingResponseDto } from '../types/Setting';
import apiClient from '../utils/apiClient';

export const getSystemSettingNew = async (property?: string): Promise<string> => {
  const response = await apiClient.get<string>(`/SystemSettings/setting-by-property/${property}`);
  return response.data;
};

export const getAllSystemSettingNew = async (category: string): Promise<Setting[]> => {
  const response = await apiClient.get<Setting[]>(`/SystemSettings/setting-by-category/${category}`);
  return response.data;
};

export const getAllPortalSystemSettings = async (): Promise<systemSettingResponseDto> => {
  const response = await apiClient.get<systemSettingResponseDto>(`/SystemSettings/all-portal-settings`);
  return response.data;
};

export const updateSystemSettingNew = async (systemSettingNew?: SystemSettingNewDto): Promise<number> => {
  const response = await apiClient.post<number>(`/SystemSettings/update-portal-settings`, systemSettingNew);
  return response.data;
};

export const updateSystemSettingName = async (systemSettingName?: SystemSettingNameDto): Promise<number> => {
  const response = await apiClient.put<number>(`/SystemSettings/${systemSettingName.id}`, systemSettingName);
  return response.data;
};